import { Box } from '@mui/material';
import { BaseProps } from 'amazon-chime-sdk-component-library-react/lib/components/ui/Base';
import React, { forwardRef, HTMLAttributes, ReactNode } from 'react';

type ObjectFit = 'contain' | 'cover' | 'fill' | 'none' | 'scale-down';

export interface VideoTileProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'css'>,
  BaseProps {
  /** The name to show on the video tile */
  nameplate?: ReactNode;
  /** Specifies which CSS object-fit value to apply to the VideoTile so that it resizes to fit its container  */
  objectFit?: ObjectFit;
  hidden?: boolean;
}

const VideoTile = forwardRef(
  (props: VideoTileProps, ref: React.Ref<HTMLVideoElement>) => {
    const { className, nameplate, hidden = false, ...rest } = props;

    return (
      <Box
        sx={{
          display: hidden ? 'none' : 'unset',

          video: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            objectFit: props.objectFit || 'cover',
          },
        }}
        className={className || ''}
        {...rest}
      >
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video ref={ref} />
      </Box>
    );
  },
);
VideoTile.displayName = 'VideoCall.VideoTile';

export default VideoTile;
